!(function () {
    "use strict";
    customElements.get("related-products") ||
        customElements.define(
            "related-products",
            class extends HTMLElement {
                constructor() {
                    super();
                }
                connectedCallback() {
                    this.loadRelatedProducts(),
                    this.loadRecentlyViewedProducts();
                }
                loadRelatedProducts() {
                    this.relatedProducts = this.querySelector(
                        "[data-related-products]"
                    );
                    if (!this.relatedProducts) {
                        this.hideTabByType("related");
                        this.maybeHideSection();
                        return;
                    }
                    const e = this.getAttribute("data-section-id"),
                        t = this.getAttribute("data-product-id"),
                        s = this.getAttribute("data-limit"),
                        r = `${theme.routes.product_recommendations_url}?section_id=${e}&limit=${s}&product_id=${t}`;
                    fetch(r)
                        .then((e) => {
                            if (!e.ok) {
                                const t = new Error(e.status);
                                throw (this.hideRelated(), t);
                            }
                            return e.text();
                        })
                        .then((e) => {
                            const t = document.createElement("div");
                            t.innerHTML = e;
                            const s = t.querySelector(
                                "[data-related-products]"
                            );
                            const productCount = s
                                ? s.querySelectorAll("[data-product-block]").length
                                : 0;
                            if (productCount > 0) {
                                this.relatedProducts.innerHTML = s.innerHTML;

                            var $slider = $('.featured-collection__slider');
                            $slider.slick({
                                dots: false,
                                arrows: true,
                                infinite: true,
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                swipe: true,
                                prevArrow: '<div class="arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192" fill="none"><path d="M72 36L132 96L72 156" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/><div xmlns="" id="divScriptsUsed" style="display: none"/><script xmlns="" id="globalVarsDetection" src="chrome-extension://cmkdbmfndkfgebldhnkbfhlneefdaaip/js/wrs_env.js"/></svg></div>',
                                nextArrow: '<div class="arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192" fill="none"><path d="M72 36L132 96L72 156" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/><div xmlns="" id="divScriptsUsed" style="display: none"/><script xmlns="" id="globalVarsDetection" src="chrome-extension://cmkdbmfndkfgebldhnkbfhlneefdaaip/js/wrs_env.js"/></svg></div>',
                                responsive: [
                                {
                                    breakpoint: 1440,
                                    settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1
                                    }
                                },
                                {
                                    breakpoint: 1140,
                                    settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1
                                    }
                                },
                                {
                                    breakpoint: 1000,
                                    settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                    arrows: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                    }
                                }
                                ]
                            });

                            // Recalculate slider height after images load to prevent clipping
                            var $sliderImages = $slider.find('img');
                            var loadedCount = 0;
                            var totalImages = $sliderImages.length;
                            if (totalImages > 0) {
                                $sliderImages.each(function() {
                                    if (this.complete) {
                                        loadedCount++;
                                        if (loadedCount === totalImages) {
                                            $slider.slick('setPosition');
                                        }
                                    } else {
                                        $(this).on('load error', function() {
                                            loadedCount++;
                                            if (loadedCount === totalImages) {
                                                $slider.slick('setPosition');
                                            }
                                        });
                                    }
                                });
                            }

                            // Hide dots and arrows when all slides fit on screen
                            function updateFeaturedDotsVisibility() {
                                var slickData = $slider.slick('getSlick');
                                var $dots = $('.featured-collection__dots');
                                var $arrows = $slider.find('.slick-arrow');
                                if (slickData.slideCount <= slickData.options.slidesToShow) {
                                    $dots.hide();
                                    $arrows.hide();
                                } else {
                                    $dots.show();
                                    $arrows.show();
                                }
                            }
                            updateFeaturedDotsVisibility();
                            $(window).on('resize', function() {
                                setTimeout(updateFeaturedDotsVisibility, 300);
                            });

                            var n = $('.featured-collection__dots .featured-collection__dot').length;
                            $('.featured-collection__dot').css('width', 100/n+'%');
                            $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                                $('.featured-collection__dot').removeClass('active');
                                $('.featured-collection__dot[data-index="'+nextSlide+'"]').addClass('active');
                            });
                            $('.featured-collection__dot').click(function(){
                                var i = $(this).data('index');
                                $slider.slick('slickGoTo', i);
                            });

                            const items = document.querySelectorAll('.product-grid-item__title');
                            let maxHeight = 0;
                            items.forEach(item => {
                                const height = item.offsetHeight;
                                if (height > maxHeight) {
                                    maxHeight = height;
                                }
                            });
                            items.forEach(item => {
                                item.style.height = maxHeight + 'px';
                            });
                            } else {
                                this.hideRelated();
                            }
                        });
                }
                loadRecentlyViewedProducts() {
                    (this.recentlyViewed = this.querySelector(
                        "recently-viewed"
                    )),
                        this.recentlyViewed &&
                            this.recentlyViewed.addEventListener(
                                "theme:recently-viewed:loaded",
                                () => {
                                    this.handleRecentlyViewedResponse();
                                }
                            );
                }
                handleRecentlyViewedResponse() {
                    const e = this.recentlyViewed.closest(
                            "[data-recently-viewed-wrapper]"
                        ),
                        t = this.recentlyViewed.querySelectorAll(
                            "[data-product-block]"
                        ),
                        s = this.recentlyViewed.querySelectorAll("[data-aos]"),
                        r = this.recentlyViewed.querySelector("grid-slider"),
                        d = this.recentlyViewed.hasAttribute("data-minimum")
                            ? parseInt(
                                  this.recentlyViewed.getAttribute(
                                      "data-minimum"
                                  )
                              )
                            : 1,
                        i = !e && t.length > 0,
                        l = e && t.length >= d,
                        a = r?.getAttribute("data-column-mobile");
                    if (i || l) {
                        l && this.classList.remove("hidden"),
                            r &&
                                (requestAnimationFrame(() => {
                                    r.dispatchEvent(
                                        new CustomEvent("theme:slider:resize", {
                                            bubbles: !0,
                                        })
                                    );
                                }),
                                r
                                    .querySelectorAll("[data-slide]")
                                    .forEach((e) => {
                                        2 == a
                                            ? (e.classList.add(
                                                  "mobile--one-half"
                                              ),
                                              e.classList.remove(
                                                  "mobile--one-whole"
                                              ))
                                            : (e.classList.add(
                                                  "mobile--one-whole"
                                              ),
                                              e.classList.remove(
                                                  "mobile--one-half"
                                              ));
                                    }));
                        let e = [];
                        this.recentlyViewed.addEventListener(
                            "theme:target:animate",
                            (t) => {
                                e.push(t.detail),
                                    e.length === s.length &&
                                        requestAnimationFrame(() =>
                                            s.forEach((e) =>
                                                e.classList.add("aos-animate")
                                            )
                                        );
                            }
                        );
                    } else {
                        this.hideRecentlyViewedTab();
                        this.maybeHideSection();
                    }
                }
                hideTabByType(type) {
                    const holder = this.querySelector("[data-tabs-holder]");
                    if (!holder) return;
                    const tab = holder.querySelector(
                        `[data-tab][data-block-type="${type}"]`
                    );
                    const tabLink = holder.querySelector(
                        `[data-tabs-link][data-block-type="${type}"]`
                    );
                    if (tab) tab.remove();
                    if (tabLink) {
                        tabLink.remove();
                        const firstLink = holder.querySelector(
                            "[data-tabs-link]"
                        );
                        if (firstLink)
                            firstLink.dispatchEvent(new Event("click"));
                    }
                }
                hideRecentlyViewedTab() {
                    if (!this.recentlyViewed) return;
                    const recentTab = this.recentlyViewed.closest("[data-tab]");
                    if (!recentTab) return;
                    const tabsHolder = recentTab.closest("[data-tabs-holder]");
                    const tabIndex = recentTab.dataset.tab;
                    const tabLink = tabsHolder?.querySelector(
                        `[data-tabs-link="${tabIndex}"]`
                    );
                    recentTab.remove();
                    tabLink?.remove();
                    const firstLink = tabsHolder?.querySelector(
                        "[data-tabs-link]"
                    );
                    if (firstLink) firstLink.dispatchEvent(new Event("click"));
                }
                maybeHideSection() {
                    const holder = this.querySelector("[data-tabs-holder]");
                    if (!holder) return;
                    const remainingTabs = holder.querySelectorAll("[data-tab]");
                    if (remainingTabs.length === 0) {
                        this.style.display = "none";
                    } else if (remainingTabs.length === 1) {
                        const tabsHead = holder.querySelector(".tabs__head");
                        const remainingLink = holder.querySelector("[data-tabs-link]");
                        const title = remainingLink?.textContent?.trim();
                        const navEl = holder.querySelector(".tabs__nav");
                        const typeClass = navEl ? [...navEl.classList].find(c => c === "font-heading" || c === "font-body" || c === "subheading-text") || "" : "";
                        if (tabsHead) tabsHead.remove();
                        if (title) {
                            const heading = document.createElement("div");
                            heading.className = "tabs__head";
                            heading.innerHTML = `<ul class="tabs__nav ${typeClass}" style="pointer-events:none;justify-content:center;"><li class="tabs__link current"><span>${title}</span></li></ul>`;
                            holder.insertBefore(heading, holder.firstChild);
                        }
                    }
                }
                hideRelated() {
                    const e = this.relatedProducts.closest("[data-tab]"),
                        t = this.relatedProducts.closest("[data-tabs-holder]"),
                        s = t?.querySelector(
                            `[data-tabs-link="${e.dataset.tab}"]`
                        );
                    e?.remove(),
                        s &&
                            (s.remove(),
                            t
                                .querySelector("[data-tabs-link]")
                                ?.dispatchEvent(new Event("click")));
                    this.maybeHideSection();
                }
            }
        );
})();